import { get, set } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default Route.extend({
  abilities: service(),
  coachingService: service(),
  navbarSettings: service(),
  router: service(),
  store: service(),

  beforeModel() {
    set(this, 'navbarSettings.title', 'Individuals');
    this.coachingService.clearSelectedIndividual();
  },

  model() {
    return this.abilities.loadCoachingAbilities().then(() => {
      return this.store
        .query('coaching/individual-summary', { filter: { template: false } })
        .then((records) => {
          return {
            individualSummaries: records,
          };
        });
    });
  },

  redirect(model) {
    if (get(model, 'individualSummaries.length') === 1) {
      let individualId = get(model, 'individualSummaries.firstObject.id');
      this.router.transitionTo('coaching.individuals.individual', individualId);
    }
  },
});
